module.exports = __webpack_public_path__ + "static/media/BabyCourse_Desktop_Main_4.7e070f8c.jpf";